<h2 mat-dialog-title class="mat-headline-small">
	{{"Ungespeicherte Änderungen." | translate : "label-unsaved-changes"}}
</h2>
<p mat-dialog-content class="mat-body-medium">
	{{"Sie Haben ungespeicherte Änderungen die verloren gehen." | translate : "paragraph-unsaved-changes"}}
</p>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">
    {{"Abbrechen" | translate : "action-cancel"}}
  </button>
  <button mat-button class="button--tertiary" (click)="onConfirm()">
    {{"Bestätigen" | translate : "action-confirm"}}
  </button>
</div>